import { Group, Text, useMantineTheme } from "@mantine/core"
import {
  IconAlertTriangle,
  IconCheck,
  IconCircleOff,
} from "@tabler/icons-react"
import { useTranslation } from "react-i18next"

import { CountryInfo, MissingCountryCause } from "@tfg/types/endpoints/agec"

import { CountryCell } from "~/components/cells/CountryCell.tsx"
import { useGetOperations } from "~/utils/operations"

type Props = {
  activityName: string
  countryInfo: CountryInfo<MissingCountryCause>
}

function isCountryInfoMissing(countryInfo: CountryInfo<MissingCountryCause>) {
  return (
    countryInfo.cause &&
    (countryInfo.cause === "not-entered-yet" ||
      countryInfo.cause === "not-validated-yet")
  )
}

export const AGECCountryProperty = ({ activityName, countryInfo }: Props) => {
  const { t } = useTranslation("products")
  const { colors } = useMantineTheme()

  const operations = useGetOperations()
  const activityInfo = operations[activityName]

  if (isCountryInfoMissing(countryInfo)) {
    return (
      <Group gap="xs">
        <IconAlertTriangle color={colors.red[6]} />
        <Text size="sm">
          {t("details.missing", { activity: activityInfo.name })}
        </Text>
      </Group>
    )
  } else {
    return (
      <Group gap="xs">
        {countryInfo.country ? (
          <IconCheck
            color={countryInfo.country ? colors.green[6] : colors.gray[0]}
          />
        ) : (
          <IconCircleOff color="gray" height={15} />
        )}
        <Text size="sm">
          {t("details.agec.activity", {
            activity: activityInfo.name,
          })}
        </Text>
        <Group>
          {countryInfo.country ? (
            <CountryCell size="sm" countryIso3166={countryInfo.country} />
          ) : (
            <Text size="sm">{t("details.agec.na")}</Text>
          )}
        </Group>
      </Group>
    )
  }
}
